import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function PrestationsCategorie() {
  const { categorie } = useParams();
  const categorieDecodee = decodeURIComponent(categorie);

  const [prestations, setPrestations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/prestations`)
      .then(res => res.json())
      .then(data => {
        const toutes = Array.isArray(data) ? data : [];
        const filtrees = toutes.filter(p => p.categorie === categorieDecodee);
        setPrestations(filtrees);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [categorieDecodee]);

  return (
    <div className="min-h-screen pt-24 pb-16">
      <section className="bg-secondary/30 py-12 sm:py-16">
        <div className="container-custom px-4">
          <Link to="/prestations" className="text-sm text-muted-foreground hover:text-primary mb-6 inline-block">
            ← Retour aux catégories
          </Link>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-3xl sm:text-4xl md:text-5xl font-serif"
          >
            {categorieDecodee}
          </motion.h1>
        </div>
      </section>

      <div className="container-custom px-4 py-10 sm:py-16">
        {loading ? (
          <div className="text-center py-16 text-muted-foreground">Chargement...</div>
        ) : prestations.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">
            Aucune prestation dans cette catégorie.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {prestations.map((p, index) => (
              <motion.div
                key={p.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                viewport={{ once: true }}
                className="border border-border rounded-sm p-6 flex flex-col gap-2"
              >
                <h2 className="text-base font-medium">{p.nom}</h2>
                {p.description && (
                  <p className="text-sm text-muted-foreground">{p.description}</p>
                )}
                <div className="flex items-center justify-between mt-3">
                  <span className="text-sm text-muted-foreground">{p.duree_minutes} min</span>
                  <span className="text-primary font-medium">{Number(p.prix_euros).toFixed(2)}€</span>
                </div>
                <Link
                  to={`/reservation?prestation=${p.id}`}
                  className="mt-3 text-center border border-primary text-primary text-sm py-2 px-4 rounded-sm hover:bg-primary hover:text-primary-foreground transition-colors"
                >
                  Réserver
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
